import { GAME_SYMBOL_APEX } from "@/game-apex/definition-symbol.mjs";
import { GAME_SYMBOL_EFT } from "@/game-eft/definition-symbol.mjs";
import { GAME_SYMBOL_FORTNITE } from "@/game-fortnite/definition-symbol.mjs";
import { GAME_SYMBOL_MINECRAFT } from "@/game-minecraft/definition.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";

export const SEARCH_PARAMS = {
  ENV: "environment",
  INDEX: "i",
};
export const ALLOW_LIST = [
  GAME_SYMBOL_APEX,
  GAME_SYMBOL_EFT,
  GAME_SYMBOL_FORTNITE,
  GAME_SYMBOL_VAL,
  GAME_SYMBOL_MINECRAFT,
];
